 export const images1 = [
    { url: "https://assets.ajio.com/cms/AJIO/WEB/Top-D-Fashionation-5090-1440x470.gif" },
          { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-MainBanner-P3-WesternwearBrands-DenislingoMissChase-Min60ExtraUpto35.jpg" },
          { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-MainBanner-P4-Trends-Flat70.jpg" },
          { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-MainBanner-P6-Handbags-CapreseLinoPerros-Upto70.jpg" },
          { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-MainBanner-P2-WinterwearWardrobe-USPAFortCollins-Min50.jpg" }
  ];
  
  export  const images2 = [
     { url: "https://assets.ajio.com/cms/AJIO/WEB/1440x128--FB.jpg" },
     { url: "https://assets.ajio.com/cms/AJIO/WEB/Paytm-1440x128pppp.jpg" },
     { url: "https://assets.ajio.com/cms/AJIO/WEB/HSBC-1440x128.jpg" },
     { url: "https://assets.ajio.com/cms/AJIO/WEB/060123-D-UHP-offers-payupto3AJIOpoints.jpg" },
     { url: "https://assets.ajio.com/cms/AJIO/WEB/060123-D-UHP-offers-payupto3AJIOpoints.jpg" },
     { url: "https://assets.ajio.com/cms/AJIO/WEB/060123-D-UHP-offers-relianceone.jpg" },
   ];
 export const images3  = [
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-26Hrs-D-P1-Ketch-Flat65.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-26Hrs-D-P1-Ketch-Flat65.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-TopBanner-P4-ONLYVeroModa-Min60.jpg" },
  ];
  

  export const images4 = [
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-TopBanner-P1-Casuals-PerfktUIshin-Min60Extraupto30.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-TopBanner-P2-DealsLikeNeverBefore-USPAFortCollins-6080.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-TopBanner-P3-PremiumWardrobeClassics-MnSScotchSoda-Upto60.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-TopBanner-P4-ONLYVeroModa-Min60.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-TopBanner-P5-NetplayAvaasa-Upto70.jpg" },
  ];

 export const images5 = [
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-JIT-P1-BestOfEthnic-KimayraKVSFab-Starting499Extraupto35.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-JIT-P2-HomegrownBestsellers-IVOCTheBearHouse-Upto80.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-JIT-P3-TopBrands-janasyaLovista-Min60.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-JIT-P4-Lifestyle-Upto60.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-JIT-P5-Winterwear-BelleFille98North-Flat50.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/117012023-UHP-D-JIT-P7-BrandsOfTheDay-GiltoGespo-Min40NEW.jpg" },
  ];
  export const images6 = [
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-JIT-P1-BestOfEthnic-KimayraKVSFab-Starting499Extraupto35.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-JIT-P2-HomegrownBestsellers-IVOCTheBearHouse-Upto80.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-JIT-P3-TopBrands-janasyaLovista-Min60.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-JIT-P4-Lifestyle-Upto60.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-JIT-P5-Winterwear-BelleFille98North-Flat50.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/117012023-UHP-D-JIT-P7-BrandsOfTheDay-GiltoGespo-Min40NEW.jpg" },
  ];

  export const images7 = [
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-D-MHP-uhphim-p1-brands-4060.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-d-MHP-uhphim-p2-brands-upto60.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-d-mhp-uhphim-p3-brands-starting199.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-d-MHP-uhphim-p4-brands-flat55.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-d-MHP-uhphim-p5-brands-min40.jpg" },
  ];

  export const images8 = [
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-UHPwomen-p1-uniqchoice-homezsparrow-starting399.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-UHPwomen-p1-nike-fila-40to50.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-UHPwomen-p3-satyapaul-scotch&soda-30to50.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-UHPwomen-p4-dnmx-trendyol-starting699.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-UHPwomen-p5-zivame-clovia-starting199.jpg" },
  ];

  export const images9 = [
    { url: "https://assets.ajio.com/cms/AJIO/WEB/060123-D-UHP-trendscarousel-upto70.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/D-UHP-trendscarousel-winterwear-edited.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/060123-D-UHP-trendscarousel-azorte.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/060123-D-UHP-trendscarousel-bestsellers.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/D-UHP-trendscarousel-womensethnic-edited.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/060123-D-UHP-trendscarousel-womenswestern.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/060123-D-UHP-trendscarousel-kidswear.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/D-UHP-trendscarousel-footwear-edited.jpg" },
  ];

  export  const images10 = [
    { url: "https://assets.ajio.com/cms/AJIO/WEB/Top-D-Fashionation-5090-1440x470.gif" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-MainBanner-P3-WesternwearBrands-DenislingoMissChase-Min60ExtraUpto35.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-MainBanner-P4-Trends-Flat70.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-MainBanner-P6-Handbags-CapreseLinoPerros-Upto70.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-MainBanner-P7-Winterwear-LeeWrnagler-Min50.jpg" },
    { url: "https://assets.ajio.com/cms/AJIO/WEB/17012023-UHP-D-MainBanner-P2-WinterwearWardrobe-USPAFortCollins-Min50.jpg" },
  ];